import { useTranslation } from "react-i18next"

import { SectionHeading } from "../components/SectionHeading"
import {
  BODY,
  CARD,
  CONTAINER,
  H3,
  ORDERED_ITEM,
  ORDERED_LIST,
  SECTION_SOFT,
  TABLE_WRAP,
  TAG_MID,
  TAG_NO,
  TAG_YES,
  TD,
  TH,
} from "../components/styles"
import { ANCHORS, SITE } from "../site-config"

/** 退款与退货政策：场景对照表 + 取消订单 + 争议处理 */
export function RefundSection() {
  const { t } = useTranslation()

  return (
    <section id={ANCHORS.refund} className={`${SECTION_SOFT} scroll-mt-[68px]`}>
      <div className={CONTAINER}>
        <SectionHeading
          eyebrow={t("official_refund_eyebrow")}
          title={t("official_refund_title")}
          lead={
            <>
              {t("official_refund_lead", {
                date: SITE.effectiveDate,
              })}
            </>
          }
        />

        <div className={TABLE_WRAP}>
          <table className="w-full min-w-[780px] border-collapse">
            <thead>
              <tr>
                <th className={TH}>{t("official_refund_th_scene")}</th>
                <th className={TH}>{t("official_refund_th_result")}</th>
                <th className={TH}>{t("official_refund_th_condition")}</th>
                <th className={TH}>{t("official_refund_th_method")}</th>
                <th className={TH}>{t("official_refund_th_fee")}</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-line">
                <td className={TD}>{t("official_refund_r1_scene")}</td>
                <td className={TD}>
                  <span className={TAG_YES}>{t("official_tag_yes")}</span>
                </td>
                <td className={TD}>{t("official_refund_r1_condition")}</td>
                <td className={TD}>{t("official_refund_r1_method")}</td>
                <td className={TD}>{t("official_refund_r1_fee")}</td>
              </tr>
              <tr className="border-b border-line">
                <td className={TD}>{t("official_refund_r2_scene")}</td>
                <td className={TD}>
                  <span className={TAG_MID}>{t("official_tag_mid")}</span>
                </td>
                <td className={TD}>
                  {t("official_refund_r2_condition", {
                    days: SITE.returnDays,
                  })}
                </td>
                <td className={TD}>{t("official_refund_r2_method")}</td>
                <td className={TD}>{t("official_refund_r2_fee")}</td>
              </tr>
              <tr className="border-b border-line">
                <td className={TD}>{t("official_refund_r3_scene")}</td>
                <td className={TD}>
                  <span className={TAG_YES}>{t("official_tag_yes")}</span>
                </td>
                <td className={TD}>{t("official_refund_r3_condition")}</td>
                <td className={TD}>{t("official_refund_r3_method")}</td>
                <td className={TD}>{t("official_refund_r3_fee")}</td>
              </tr>
              <tr className="border-b border-line">
                <td className={TD}>{t("official_refund_r4_scene")}</td>
                <td className={TD}>
                  <span className={TAG_NO}>{t("official_tag_no")}</span>
                </td>
                <td className={TD}>{t("official_refund_r4_condition")}</td>
                <td className={TD}>{t("official_refund_r4_method")}</td>
                <td className={TD}>{t("official_refund_r4_fee")}</td>
              </tr>
              <tr>
                <td className={TD}>{t("official_refund_r5_scene")}</td>
                <td className={TD}>
                  <span className={TAG_YES}>{t("official_tag_yes")}</span>
                </td>
                <td className={TD}>{t("official_refund_r5_condition")}</td>
                <td className={TD}>{t("official_refund_r5_method")}</td>
                <td className={TD}>{t("official_refund_r5_fee")}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-6 grid gap-6 lg:grid-cols-2">
          <article className={CARD}>
            <h3 className={H3}>{t("official_refund_cancel_title")}</h3>
            <p className={BODY}>{t("official_refund_cancel_text")}</p>
          </article>

          <article id={ANCHORS.dispute} className={CARD}>
            <h3 className={H3}>{t("official_refund_dispute_title")}</h3>
            <ol className={ORDERED_LIST}>
              <li className={ORDERED_ITEM}>
                {t("official_refund_dispute_li1")}
              </li>
              <li className={ORDERED_ITEM}>
                {t("official_refund_dispute_li2", {
                  days: SITE.disputeDays,
                })}
              </li>
              <li className={ORDERED_ITEM}>
                {t("official_refund_dispute_li3")}
              </li>
              <li className={ORDERED_ITEM}>
                {t("official_refund_dispute_li4")}
              </li>
            </ol>
          </article>
        </div>
      </div>
    </section>
  )
}
